import api from '../../../services/Api';

import {
  IAuditoriaResultado,
  IEmpresaAuditoria,
  IPeriodoAuditoria,
  TributoAuditoria,
} from '../interfaces/IAuditoria';
import { TipoAcessoAuditoria } from '../../../interfaces/IClienteAcessoAuditoria';

export const AuditoriaService = {
  async listarEmpresas(): Promise<IEmpresaAuditoria[]> {
    const response = await api.get<IEmpresaAuditoria[]>('auditoria/empresas');
    return response.data || [];
  },

  async listarPeriodos(empresaId: number): Promise<IPeriodoAuditoria[]> {
    if (!empresaId) return [];

    const response = await api.get<IPeriodoAuditoria[]>('auditoria/periodos', {
      params: { empresaIds: empresaId },
    });

    return response.data || [];
  },

  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
    tributo: TributoAuditoria;
  }): Promise<IAuditoriaResultado> {
    const response = await api.get<IAuditoriaResultado>('auditoria/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
        tributo: params.tributo,
      },
    });

    return {
      cards: response.data?.cards || [],
      empresas: response.data?.empresas || [],
    };
  },

  async buscarMeuAcesso(): Promise<TipoAcessoAuditoria> {
    const response = await api.get<{ tierEfetivo: TipoAcessoAuditoria }>('auditoria/meu-acesso');
    return response.data?.tierEfetivo ?? 'FullPremium';
  },
};
